import { Badge, BadgeProps, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../enums/modalId'
import { TrackingContext } from '../../enums/trackingContext'
import { UpgradeSubscriptionModal } from '../Modal/upgradeSubscriptionModal'

interface UpgradeBadgeProps extends BadgeProps {
  trackingContext: TrackingContext
}

export const UpgradeBadge = ({ children, trackingContext, ...rest }: UpgradeBadgeProps): ReactElement => {
  const { t } = useTranslation()
  const { open: openUpgradeSubscriptionModal } = useModal(ModalId.UpgradeSubscriptionModal)

  return (
    <>
      <Badge {...rest} onClick={openUpgradeSubscriptionModal}>
        {children || t('upgrade')}
      </Badge>
      <UpgradeSubscriptionModal id={ModalId.UpgradeSubscriptionModal} trackingContext={trackingContext} />
    </>
  )
}
